import moment from 'moment'

import {
  ListItem as MuiListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  styled,
} from '@mui/material'
import { InsertDriveFile as FileIcon } from '@mui/icons-material'

import DocumentFileIcon from './DocumentFileIcon'
import ImageFileIcon from './ImageFileIcon'
import ZipFileIcon from './ZipFileIcon'

const FILE_ICON_COLOUR = '#6D6C6D'
const MAX_FILE_NAME_LENGTH = 45

function getFileExt(fileName) {
  const fileNameSplit = fileName.split('.')
  return fileNameSplit[fileNameSplit.length - 1]
}

function formatBytes(bytes) {
  if (!bytes) {
    return '0 B'
  }

  var sizes = [
    {
      label: 'KB',
      size: 1000,
      decimalPlaces: 0,
    },
    {
      label: 'MB',
      size: 1000000,
      decimalPlaces: 1,
    },
    {
      label: 'GB',
      size: 1000000000,
      decimalPlaces: 1,
    },
  ]

  for (var i = sizes.length - 1; i >= 0; i--) {
    if (bytes >= sizes[i].size) {
      var x = (bytes / sizes[i].size).toFixed(sizes[i].decimalPlaces)
      return `${x} ${sizes[i].label}`
    }
  }

  return `${bytes} B`
}

function truncateFileName(fileName) {
  if (fileName.length > MAX_FILE_NAME_LENGTH) {
    return fileName.slice(0, MAX_FILE_NAME_LENGTH - 3) + '...'
  } else {
    return fileName
  }
}

const ListItem = styled(MuiListItem)(({ theme }) => ({
  borderBottom: '1px solid lightGray',
  '& .MuiListItemIcon-root': {
    minWidth: 36,
  },
}))

const DownloadListItem = ({ file }) => {
  const fileExt = getFileExt(file.name)
  var fileIcon = <FileIcon />

  if (fileExt === 'png' || fileExt === 'jpg' || fileExt === 'jpeg') {
    fileIcon = <ImageFileIcon width={25} height={25} fill={FILE_ICON_COLOUR} />
  } else if (fileExt === 'txt' || fileExt === 'doc' || fileExt === 'docx') {
    fileIcon = (
      <DocumentFileIcon width={25} height={25} fill={FILE_ICON_COLOUR} />
    )
  } else if (fileExt === 'zip' || fileExt === 'tar' || fileExt === 'gz') {
    fileIcon = <ZipFileIcon width={25} height={20} fill={FILE_ICON_COLOUR} />
  }

  const fileNameTruncated = file.name.length > MAX_FILE_NAME_LENGTH
  return (
    <Tooltip
      title={file.name}
      arrow
      disableFocusListener={!fileNameTruncated}
      disableHoverListener={!fileNameTruncated}
      disableTouchListener={!fileNameTruncated}
      sx={{ maxWidth: '500px' }}
    >
      <ListItem button dense onClick={() => window.open(file.url, '_blank')}>
        <ListItemIcon sx={{ mr: '6px' }}>{fileIcon}</ListItemIcon>
        <ListItemText
          primary={truncateFileName(file.name)}
          secondary={`${moment(file.timestamp).format(
            'DD/MM/YYYY'
          )} ${formatBytes(file.size)}`}
        ></ListItemText>
      </ListItem>
    </Tooltip>
  )
}

export default DownloadListItem
